import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, Calendar, MessageSquare, Trophy, Award, Users } from 'lucide-react';

const MenuSuperior = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/', label: 'Início', icon: Home },
    { path: '/programacao', label: 'Programação', icon: Calendar },
    { path: '/comunicados', label: 'Comunicados', icon: MessageSquare },
    { path: '/contato', label: 'Contato', icon: Users },
    { path: '/ranking', label: 'Ranking', icon: Award },
    { path: '/quiz', label: 'Quiz', icon: Trophy },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <motion.div 
      className="flex justify-end items-center mb-8 px-4 sm:px-6 lg:px-8 w-full"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <nav className="hidden md:flex space-x-1">
        {navItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 flex items-center space-x-2 ${
                isActive(item.path)
                  ? 'bg-golden-500 text-white shadow-md'
                  : 'text-amazonia-dark-700 hover:bg-amazonia-green-50 hover:text-amazonia-green-700'
              }`}
            >
              <IconComponent className="w-5 h-5" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </motion.div>
  );
};

export default MenuSuperior;
